module.exports = __webpack_public_path__ + "fonts/3fe868a.ttf";